import { Outlet, useLocation } from 'react-router-dom';
import { useState, useCallback, useEffect } from 'react';
import ClientSidebar from './ClientSidebar';
import Header from './Header';
import { useAuth } from '@/contexts/AuthContext';

export default function ClientLayout() {
  useAuth();
  const location = useLocation();
  const isChatPage = location.pathname === '/client/chat';
  const [mobileMenuOpen, setMobileMenuOpen] = useState(false);

  const toggleMobileMenu = useCallback(() => setMobileMenuOpen(prev => !prev), []);
  const closeMobileMenu = useCallback(() => setMobileMenuOpen(false), []);

  // Close mobile menu on route change
  useEffect(() => {
    setMobileMenuOpen(false);
  }, [location.pathname]);

  return (
    <div className="flex h-screen bg-gradient-to-br from-gray-50 to-slate-100 dark:from-slate-950 dark:to-slate-900 transition-colors">
      <ClientSidebar mobileOpen={mobileMenuOpen} onMobileClose={closeMobileMenu} />
      <div className="flex flex-1 flex-col overflow-hidden">
        <Header onToggleMobileMenu={toggleMobileMenu} />
        <main className="flex-1 overflow-auto relative">
          {isChatPage ? (
            <Outlet key={location.pathname} />
          ) : (
            <div className="relative" key={location.pathname}>
              <div className="absolute inset-0 bg-[radial-gradient(circle_at_50%_120%,rgba(120,119,198,0.1),rgba(255,255,255,0))] dark:bg-[radial-gradient(circle_at_50%_120%,rgba(120,119,198,0.05),rgba(255,255,255,0))]" />
              <div className="relative z-10">
                <Outlet />
              </div>
            </div>
          )}
        </main>
      </div>
    </div>
  );
}
